import axios from "axios";
import { createFormData } from "./formData";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const addDigitalAsset = async (
  payload: Record<string, unknown>,
): Promise<void> => {
  const response = await axios.post(API_BASE_URL, createFormData(payload), {
    validateStatus: () => true,
  });

  if (response.status === 409) {
    throw new Error(String(response.data));
  }

  if (response.status !== 201) {
    throw new Error("Cannot save Digital Asset.");
  }
};
